import { CustomIconButtonColor } from '../../UiComponentsLibrary/CustomIconButton/constants/CustomIconButtonColor';
import { pencil, lock, trash, refresh } from '@amzn/storm-ui-icons';
import { ART_EVENT_STATUS } from '../constants/artEventStatus';
import { ArtEventInterface } from '../interfaces/editArtEventInterfaces';

export const artEventTableActions = {
  editArtEvent: {
    icon: pencil,
    backgroundColor: CustomIconButtonColor.pencil,
    labelKey: 'edit-art-event-action-label',
  },
  freezeArtEvent: {
    icon: lock,
    backgroundColor: CustomIconButtonColor.cancel,
    labelKey: 'freeze-art-event-action-label',
  },
  refreshArtEvent: {
    icon: refresh,
    backgroundColor: CustomIconButtonColor.restore,
    labelKey: 'activate-art-event-action-label',
  },
  deleteArtEvent: {
    icon: trash,
    backgroundColor: CustomIconButtonColor.delete,
    labelKey: 'delete-art-event-action-label',
  },
};

export const getTableActionButtons = (row: ArtEventInterface, canEdit = true) => {
  const isFrozen = row.status === ART_EVENT_STATUS.FROZEN;
  const isDeleted = row.status === ART_EVENT_STATUS.DELETED;
  const isStatusDisabled = isFrozen || isDeleted;
  const isDisabled = isStatusDisabled || !canEdit;

  return [
    {
      action: 'edit',
      config: artEventTableActions.editArtEvent,
      disabled: isDisabled,
    },
    {
      action: isFrozen ? 'activate' : 'freeze',
      config: isFrozen
        ? artEventTableActions.refreshArtEvent
        : artEventTableActions.freezeArtEvent,
      disabled: !canEdit || (isStatusDisabled && !isFrozen),
    },
    {
      action: 'delete',
      config: artEventTableActions.deleteArtEvent,
      disabled: isDisabled,
    },
  ];
};
